import React from 'react';
import { useHistory } from 'react-router-dom';

import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import LoadingSkeleton from 'pages/Teachers/Insights/components/LoadingSkeleton';

import styles from './style.module.scss';

const ClassroomHeader = ({ sectionDetails, studentsCount }) => {
  const history = useHistory();

  if (!sectionDetails) {
    return <LoadingSkeleton />;
  }

  const { tracker_name, section_name } = sectionDetails;

  return (
    <div className={styles.container}>
      <button
        className={styles.back}
        onClick={() => {
          history.goBack();
        }}
      >
        <ArrowBackIcon />
        <span>Back</span>
      </button>

      <div className={styles.titles}>
        <h1 className={styles.heading}>{tracker_name}</h1>
        {section_name && <p className={styles.subheading}>{section_name}</p>}
      </div>
      {studentsCount === 0 ? (
        <CircularProgress />
      ) : (
        <div className={styles.studentCount}>{studentsCount} students</div>
      )}
    </div>
  );
};

export default ClassroomHeader;
